import { render, staticRenderFns } from "./ChartCanvas.vue?vue&type=template&id=4e20b706&scoped=true"
import script from "./ChartCanvas.vue?vue&type=script&lang=js"
export * from "./ChartCanvas.vue?vue&type=script&lang=js"
import style0 from "./ChartCanvas.vue?vue&type=style&index=0&id=4e20b706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e20b706",
  null
  
)

export default component.exports